import ArrowDownward from '@mui/icons-material/ArrowDownward';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import { Button } from '@/ui';

export type DomainSortDirection = 'asc' | 'desc';

interface DomainSortButtonProps {
  direction: DomainSortDirection;
  onToggle: () => void;
}

/**
 * Flips the Domains list between DomainID ascending and descending. One component for the
 * three criteria trees, so the affordance reads the same in each.
 *
 * The description is a native `title`, not a MUI Tooltip: Tooltip swaps the attribute for an
 * `aria-label`, and DomainAffiliate's test finds this button by its title.
 */
export function DomainSortButton({ direction, onToggle }: DomainSortButtonProps) {
  const ascending = direction === 'asc';
  return (
    <Button
      size='sm'
      color='outline-secondary'
      type='button'
      title={`Domains sorted by DomainID (${ascending ? 'ascending' : 'descending'}). Click to switch order.`}
      endIcon={ascending ? <ArrowUpward fontSize='inherit' /> : <ArrowDownward fontSize='inherit' />}
      onClick={onToggle}
      sx={{ whiteSpace: 'nowrap' }}
    >
      DomainID
    </Button>
  );
}
